import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const PromptText = styled.div`
  font-size: 12px;
  color: ${COLORS.secondaryDark};
`

export const AIHistoryItemContainer = styled.div`
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid ${COLORS.borderColor};
  }
`
